import type { IUserKeywordGroup } from "app/services/keyword-groups";
import type { ActivationObjectSchema } from "app/pages/activation/types/api";

export enum EMonitorKeywordsGraphTabs {
    ShareOfVoice,
    Volume,
}

export interface IMonitorKeywordsGraphProps {
    keywordGroup: IUserKeywordGroup;
    activationSets: ActivationObjectSchema[];
    isActivationSetError: boolean;
    isActivationSetPlaceholderData: boolean;
}
